// Accept complete measured pairs only. In particular, absent values are never (0, 0).
export function photoLocation(latitude,longitude){
 if(!['number','string'].includes(typeof latitude)||!['number','string'].includes(typeof longitude)||String(latitude).trim()===''||String(longitude).trim()==='')return null;
 const lat=Number(latitude),lng=Number(longitude);
 return Number.isFinite(lat)&&Number.isFinite(lng)&&Math.abs(lat)<=90&&Math.abs(lng)<=180?{lat,lng}:null;
}
